import App from "./App"
import { BrowserRouter } from "react-router-dom";

// React toastify
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './siteWrapperRoot.css'

// Rainbowkit + wagmi
import '@rainbow-me/rainbowkit/styles.css';
import {
  RainbowKitProvider,
  connectorsForWallets,
  darkTheme
} from '@rainbow-me/rainbowkit';

import {
  injectedWallet,
  rainbowWallet,
  metaMaskWallet,
  coinbaseWallet,
  walletConnectWallet,
  trustWallet,
  argentWallet,
  ledgerWallet,
  braveWallet,
} from '@rainbow-me/rainbowkit/wallets'

import { configureChains, createClient, WagmiConfig } from 'wagmi';
import { mainnet, goerli } from 'wagmi/chains';
import { publicProvider } from 'wagmi/providers/public';

const { chains, provider, webSocketProvider } = configureChains(
  [goerli],
  [publicProvider()]
);

const connectors = connectorsForWallets([
  {
    groupName: 'Recommended',
    wallets: [
      metaMaskWallet({ chains }),
      injectedWallet({ chains }),
    ],
  },
  {
    groupName: 'Other',
    wallets: [
      trustWallet({ chains }),
      argentWallet({ chains }),
      ledgerWallet({ chains }),
      coinbaseWallet({ appName: 'bbcNFT', chains }),
      braveWallet({
        chains,
        shimDisconnect: true,
      }),
      walletConnectWallet({ chains }),
      rainbowWallet({ chains }),
    ],
  },
])

const wagmiClient = createClient({
  autoConnect: true,
  connectors,
  provider,
  webSocketProvider
})

export default function SiteWrapperRoot() {
  return (
      <>
      <WagmiConfig client={wagmiClient}>

          <RainbowKitProvider 
          chains={chains}
          modalSize='compact'
          theme={darkTheme()}>

              <BrowserRouter>
                  <App />
              </BrowserRouter>

          </RainbowKitProvider>

      </WagmiConfig>

      <ToastContainer 
      position='bottom-center'
      hideProgressBar
      autoClose={3000}
      limit={3}
      pauseOnFocusLoss={false}
      theme='dark'/>
      </>
  )
}